export default {
  WIDGET_TOKEN: 'widget-token',
  WISHLIST: 'wishlist',
  SEARCH_TYPE: 'search-type',
  SEARCH_VIEW: 'search-view',
  MERCHANT_SERVICES_VIEW: 'merchant-services-view',
}
